import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AuthContext from "../context";


export default function AuthLayout() {
  const [authState, setAuthState] = useState({
    loginView: true,
    smsVerificationView: false,
    twoFactorVerification: false,
    passwordResetView: false,
    MFATraceId: "",
    

    memberLoginInputs: {
      email: "",
      password: ""
    },
    userLoginInputs: {
      customerNumber: "",
      password: "",
      mfaTraceId: "",
    }
  });

  return (
    <AuthContext.Provider value={{ authState, setAuthState }}>
      <Outlet />
    </AuthContext.Provider>
  );
}
